var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPngFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37305 13.75C10.4086 13.75 11.248 12.9105 11.248 11.875C11.248 10.8395 10.4086 10 9.37305 10C8.33751 10 7.49805 10.8395 7.49805 11.875C7.49805 12.9105 8.33751 13.75 9.37305 13.75Z",
    stroke: "#2D3748",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.123 17.5L11.248 15L7.49805 20H22.498L16.873 12.5L13.123 17.5Z",
    stroke: "#2D3748",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9981 5H4.99805C3.6193 5 2.49805 6.12125 2.49805 7.5V22.5C2.49805 23.8787 3.6193 25 4.99805 25H24.9981C26.3768 25 27.4981 23.8787 27.4981 22.5V7.5C27.4981 6.12125 26.3768 5 24.9981 5ZM4.99805 22.5V7.5H24.9981L25.0005 22.5H4.99805Z",
    stroke: "#2D3748",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPngFormat);
export default __webpack_public_path__ + "static/media/PngFormat.71685c69226153ba103a5826acd6ec9c.svg";
export { ForwardRef as ReactComponent };